module.exports = __webpack_public_path__ + "static/media/other-expense.b4448d85.svg";